import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // Para redirigir
import '../css/ReporteConsolidado.css';

function ReporteConsolidado() {
  const [ingresosConsolidados, setIngresosConsolidados] = useState({});
  const [egresosConsolidados, setEgresosConsolidados] = useState({});
  const [disponible, setDisponible] = useState(0);

  const navigate = useNavigate(); // Para la navegación
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    // Obtener Ingresos
    axios.get(`${apiUrl}/Donantes/Donaciones`)
      .then((response) => {
        const data = response.data;
        const consolidados = consolidarPorConcepto(data);
        setIngresosConsolidados(consolidados);
      })
      .catch((error) => {
        console.error('Error al obtener los ingresos:', error);
      });

    // Obtener Egresos
    axios.get(`${apiUrl}/Donantes/Egresos`)
      .then((response) => {
        const data = response.data;
        const consolidados = consolidarPorConcepto(data);
        setEgresosConsolidados(consolidados);
      })
      .catch((error) => {
        console.error('Error al obtener los egresos:', error);
      });
  }, [apiUrl]);

  // Función para consolidar valores por concepto
  const consolidarPorConcepto = (items) => {
    return items.reduce((acc, item) => {
      const { concepto, valor } = item;
      if (!acc[concepto]) {
        acc[concepto] = 0;
      }
      acc[concepto] += valor;
      return acc;
    }, {});
  };

  // Calcular disponible
  useEffect(() => {
    const totalIngresos = Object.values(ingresosConsolidados).reduce((acc, valor) => acc + valor, 0);
    const totalEgresos = Object.values(egresosConsolidados).reduce((acc, valor) => acc + valor, 0);
    setDisponible(totalIngresos - totalEgresos);
  }, [ingresosConsolidados, egresosConsolidados]);

  // Función para formatear valores como moneda
  const formatCurrency = (value) => {
    return Number(value).toLocaleString('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  // Redirigir a la página de opciones
  const handleRegresar = () => {
    navigate('/opciones'); // Cambia '/opciones' por la ruta correcta
  };

  return (
    <div className="consolidado-container">
      <h1>Reporte Consolidado</h1>

      <div className="tables-container">
        {/* Tabla de Ingresos */}
        <div className="table-wrapper">
          <h2>Ingresos Consolidados</h2>
          <table>
            <thead>
              <tr>
                <th>Concepto</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(ingresosConsolidados).map(([concepto, valor]) => (
                <tr key={concepto}>
                  <td>{concepto}</td>
                  <td>{formatCurrency(valor)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Tabla de Egresos */}
        <div className="table-wrapper">
          <h2>Egresos Consolidados</h2>
          <table>
            <thead>
              <tr>
                <th>Concepto</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(egresosConsolidados).map(([concepto, valor]) => (
                <tr key={concepto}>
                  <td>{concepto}</td>
                  <td>{formatCurrency(valor)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Disponible */}
      <div className="disponible-container">
        <h3>Disponible: {formatCurrency(disponible)}</h3>
      </div>

      {/* Botón de regreso */}
      <div className="button-container">
        <button className="btn-regresar" onClick={handleRegresar}>
          Regresar a Opciones
        </button>
      </div>
    </div>
  );
}

export default ReporteConsolidado;
